import React, { useState } from 'react';

import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Button from '@mui/material/Button';
import CheckIcon from '@mui/icons-material/Check';
import CloseIcon from '@mui/icons-material/Close';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

interface CapabilityChipsProps {
    items: {
        label: string;
        available: boolean;
    }[];
}

const CapabilityChips: React.FC<CapabilityChipsProps> = (props) => {
    const { items = [] } = props;
    const [showMissing, setShowMissing] = useState(false);
    const available = items.filter((i) => i.available);
    const missing = items.filter((i) => !i.available);

    return (
        <Box>
            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
                {available.map((c) => (
                    <Chip
                        key={c.label}
                        icon={<CheckIcon />}
                        label={c.label}
                        color="success"
                        variant="outlined"
                        sx={{
                            bgcolor: 'rgba(46,125,87,0.08)',
                            borderColor: 'rgba(46,125,87,0.24)'
                        }}
                    />
                ))}
            </Box>

            {missing.length > 0 && (
                <Box sx={{ mt: 2 }}>
                    <Button
                        size="small"
                        color="inherit"
                        onClick={() => setShowMissing((v) => !v)}
                        startIcon={(
                            <ExpandMoreIcon
                                sx={{
                                    transition: 'transform 0.2s',
                                    transform: showMissing ? 'rotate(180deg)' : 'none'
                                }}
                            />
                        )}
                        sx={{ color: 'text.secondary' }}
                    >
                        {showMissing ? 'Dölj saknade' : `Visa saknade (${missing.length})`}
                    </Button>
                    {showMissing && (
                        <Box sx={{
                            mt: 1,
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: 1
                        }}
                        >
                            {missing.map((c) => (
                                <Chip
                                    key={c.label}
                                    icon={<CloseIcon />}
                                    label={c.label}
                                    variant="outlined"
                                    sx={{
                                        color: 'text.secondary'
                                    }}
                                />
                            ))}
                        </Box>
                    )}
                </Box>
            )}
        </Box>
    );
};

export default CapabilityChips;
